// ../../node_modules/wirejs-web-worker/dist/index.js
function isRequest(o) {
  return typeof o === "object" && o.__type === "request";
}
function isCallbackRequest(o) {
  return typeof o === "object" && o.__type === "callbackRequest";
}
function isCallbackDescriptor(o) {
  return typeof o === "object" && o.__type === "callback";
}
function isResponse(o) {
  return typeof o === "object" && o.__type === "response";
}
function isGarbageCollection(o) {
  return typeof o === "object" && o.__type === "garbage";
}
var callbackFunctions = /* @__PURE__ */ new Map();
var callbackDescriptors = /* @__PURE__ */ new Map();
var requests = /* @__PURE__ */ new Map();
function createCallbackFunction(callback) {
  const f = (...args) => {
    return new Promise((resolve, reject) => {
      const requestId = crypto.randomUUID();
      requests.set(requestId, { resolve, reject });
      postMessage({
        __type: "callbackRequest",
        requestId,
        args: dehydrateCallbacks(args),
        target: callback.callbackId
      });
    });
  };
  callbackDescriptors.set(callback.callbackId, new WeakRef(f));
  return f;
}
function createCallbackDescriptor(f) {
  const callbackId = crypto.randomUUID();
  callbackFunctions.set(callbackId, f);
  return {
    __type: "callback",
    callbackId
  };
}
function hydrateCallbacks(o) {
  if (isCallbackDescriptor(o)) {
    return createCallbackFunction(o);
  } else if (!o) {
    return o;
  } else if (Array.isArray(o)) {
    const copied = [];
    for (let i = 0; i < o.length; i++) {
      copied[i] = hydrateCallbacks(o[i]);
    }
    return copied;
  } else if (typeof o === "object") {
    const copied = {};
    for (const [k, v] of Object.entries(o)) {
      copied[k] = hydrateCallbacks(v);
    }
    return copied;
  }
  return o;
}
function dehydrateCallbacks(o) {
  if (typeof o === "function") {
    return createCallbackDescriptor(o);
  } else if (!o) {
    return o;
  } else if (Array.isArray(o)) {
    const copied = [];
    for (let i = 0; i < o.length; i++) {
      copied[i] = dehydrateCallbacks(o[i]);
    }
    return copied;
  } else if (typeof o === "object") {
    const copied = {};
    for (const [k, v] of Object.entries(o)) {
      copied[k] = dehydrateCallbacks(v);
    }
    return copied;
  }
  return o;
}
var garbageCollectionLoop = void 0;
function ensureGarbageCollectionIsRunning(send) {
  garbageCollectionLoop = garbageCollectionLoop ?? setInterval(() => {
    for (const callbackId of Object.keys(callbackDescriptors)) {
      const ref = callbackDescriptors.get(callbackId);
      if (!ref.deref) {
        send({ __type: "garbage", callbackId });
      }
    }
  }, 1e3);
}
async function handleRequest(f, requestId, args, respond) {
  try {
    const result = dehydrateCallbacks(await f(...hydrateCallbacks(args || [])));
    respond({ __type: "response", requestId, result });
  } catch (error) {
    respond({ __type: "response", requestId, error });
  }
}
function messageHandler(send, callables) {
  ensureGarbageCollectionIsRunning(send);
  return async (message) => {
    const { data } = message;
    if (isRequest(data)) {
      handleRequest(callables[data.method], data.requestId, data.args, send);
    } else if (isCallbackRequest(data)) {
      handleRequest(callbackFunctions.get(data.target), data.requestId, data.args, send);
    } else if (isResponse(data)) {
      const request = requests.get(data.requestId);
      if (!request)
        return;
      const hydratedResult = hydrateCallbacks(data.result);
      requests.delete(data.requestId);
      data.error ? request.reject(data.error) : request.resolve(hydratedResult);
    } else if (isGarbageCollection(data)) {
      callbackFunctions.delete(data.callbackId);
    }
  };
}
function buildWorker(workerBundle2) {
  const worker2 = new Worker(URL.createObjectURL(new Blob([workerBundle2], { type: "text/javascript" })));
  worker2.onmessage = messageHandler((m) => worker2?.postMessage(m), {});
  return worker2;
}
function proxyWorker(workerBundle2) {
  let worker2;
  return new Proxy({}, {
    get(_target, method) {
      worker2 = worker2 ?? buildWorker(workerBundle2);
      return (...args) => {
        return new Promise((resolve, reject) => {
          const requestId = crypto.randomUUID();
          requests.set(requestId, { resolve, reject });
          worker2.postMessage({
            __type: "request",
            method,
            requestId,
            args: dehydrateCallbacks(args)
          });
        });
      };
    }
  });
}

// dist/client.1bcdf0d8-7269-440f-b0da-bfe2e23e064a.ts
var workerBundle = '"use strict";\n(() => {\n  // ../../node_modules/wirejs-web-worker/dist/index.js\n  function isRequest(o) {\n    return typeof o === "object" && o.__type === "request";\n  }\n  function isCallbackRequest(o) {\n    return typeof o === "object" && o.__type === "callbackRequest";\n  }\n  function isCallbackDescriptor(o) {\n    return typeof o === "object" && o.__type === "callback";\n  }\n  function isResponse(o) {\n    return typeof o === "object" && o.__type === "response";\n  }\n  function isGarbageCollection(o) {\n    return typeof o === "object" && o.__type === "garbage";\n  }\n  var callbackFunctions = /* @__PURE__ */ new Map();\n  var callbackDescriptors = /* @__PURE__ */ new Map();\n  var requests = /* @__PURE__ */ new Map();\n  function createCallbackFunction(callback) {\n    const f = (...args) => {\n      return new Promise((resolve, reject) => {\n        const requestId = crypto.randomUUID();\n        requests.set(requestId, { resolve, reject });\n        postMessage({\n          __type: "callbackRequest",\n          requestId,\n          args: dehydrateCallbacks(args),\n          target: callback.callbackId\n        });\n      });\n    };\n    callbackDescriptors.set(callback.callbackId, new WeakRef(f));\n    return f;\n  }\n  function createCallbackDescriptor(f) {\n    const callbackId = crypto.randomUUID();\n    callbackFunctions.set(callbackId, f);\n    return {\n      __type: "callback",\n      callbackId\n    };\n  }\n  function hydrateCallbacks(o) {\n    if (isCallbackDescriptor(o)) {\n      return createCallbackFunction(o);\n    } else if (!o) {\n      return o;\n    } else if (Array.isArray(o)) {\n      const copied = [];\n      for (let i = 0; i < o.length; i++) {\n        copied[i] = hydrateCallbacks(o[i]);\n      }\n      return copied;\n    } else if (typeof o === "object") {\n      const copied = {};\n      for (const [k, v] of Object.entries(o)) {\n        copied[k] = hydrateCallbacks(v);\n      }\n      return copied;\n    }\n    return o;\n  }\n  function dehydrateCallbacks(o) {\n    if (typeof o === "function") {\n      return createCallbackDescriptor(o);\n    } else if (!o) {\n      return o;\n    } else if (Array.isArray(o)) {\n      const copied = [];\n      for (let i = 0; i < o.length; i++) {\n        copied[i] = dehydrateCallbacks(o[i]);\n      }\n      return copied;\n    } else if (typeof o === "object") {\n      const copied = {};\n      for (const [k, v] of Object.entries(o)) {\n        copied[k] = dehydrateCallbacks(v);\n      }\n      return copied;\n    }\n    return o;\n  }\n  var garbageCollectionLoop = void 0;\n  function ensureGarbageCollectionIsRunning(send) {\n    garbageCollectionLoop = garbageCollectionLoop ?? setInterval(() => {\n      for (const callbackId of Object.keys(callbackDescriptors)) {\n        const ref = callbackDescriptors.get(callbackId);\n        if (!ref.deref) {\n          send({ __type: "garbage", callbackId });\n        }\n      }\n    }, 1e3);\n  }\n  async function handleRequest(f, requestId, args, respond) {\n    try {\n      const result = dehydrateCallbacks(await f(...hydrateCallbacks(args || [])));\n      respond({ __type: "response", requestId, result });\n    } catch (error) {\n      respond({ __type: "response", requestId, error });\n    }\n  }\n  function messageHandler(send, callables) {\n    ensureGarbageCollectionIsRunning(send);\n    return async (message) => {\n      const { data } = message;\n      if (isRequest(data)) {\n        handleRequest(callables[data.method], data.requestId, data.args, send);\n      } else if (isCallbackRequest(data)) {\n        handleRequest(callbackFunctions.get(data.target), data.requestId, data.args, send);\n      } else if (isResponse(data)) {\n        const request = requests.get(data.requestId);\n        if (!request)\n          return;\n        const hydratedResult = hydrateCallbacks(data.result);\n        requests.delete(data.requestId);\n        data.error ? request.reject(data.error) : request.resolve(hydratedResult);\n      } else if (isGarbageCollection(data)) {\n        callbackFunctions.delete(data.callbackId);\n      }\n    };\n  }\n  function SingleWorker(callables) {\n    self.onmessage = messageHandler(postMessage, callables);\n    return callables;\n  }\n\n  // src/index.ts\n  var worker = SingleWorker({\n    async count(upTo, options) {\n      let lastUpdate = /* @__PURE__ */ new Date();\n      options?.tick?.(0);\n      let c = 0;\n      for (let i = 0; i < upTo; i++) {\n        let current = /* @__PURE__ */ new Date();\n        if (current.getTime() - lastUpdate.getTime() > 50) {\n          options?.tick?.(i / upTo);\n          lastUpdate = current;\n        }\n        c++;\n      }\n      options?.tick?.(1);\n      return c;\n    }\n  });\n})();\n';
var worker = proxyWorker(workerBundle);
export {
  worker
};
